import { xenvActionFactory } from '../xenv';
import { alimpLocate, alipayLocate, 
// bdmpLocate,
cappLocate, cowxmpLocate, cxwxmpLocate, driverLocate, drwxmpLocate, gjwxmpLocate, h5Locate, kfalimpLocate, kfdriverLocate, kfdwxmpLocate, kfpassengerLocate, kfwxmpLocate, mqqLocate, passengerLocate, qjwxmpLocate, 
// qqmpLocate,
thwxmpLocate, weixinLocate, wxmpLocate, yxwxmpLocate, gaswxmpLocate, esappLocate, hitchappLocate, sfcwxmpLocate, hywxmpLocate, hydriverLocate } from '../platform/xenv';
const xenvLocateConfig = {
    'alimp': alimpLocate,
    'alipay': alipayLocate,
    // 'bdmp': bdmpLocate,
    'capp': cappLocate,
    'cowxmp': cowxmpLocate,
    'cxwxmp': cxwxmpLocate,
    'sfcwxmp': sfcwxmpLocate,
    'driver': driverLocate,
    'drwxmp': drwxmpLocate,
    'gjwxmp': gjwxmpLocate,
    'h5': h5Locate,
    'kfalimp': kfalimpLocate,
    'kfdriver': kfdriverLocate,
    'kfdwxmp': kfdwxmpLocate,
    'kfpassenger': kfpassengerLocate,
    'kfwxmp': kfwxmpLocate,
    'mqq': mqqLocate,
    'passenger': passengerLocate,
    'esapp': esappLocate,
    'qjwxmp': qjwxmpLocate,
    // 'qqmp': qqmpLocate,
    'thwxmp': thwxmpLocate,
    'weixin': weixinLocate,
    'wxmp': wxmpLocate,
    'yxwxmp': yxwxmpLocate,
    'gaswxmp': gaswxmpLocate,
    'hitchapp': hitchappLocate,
    'hywxmp': hywxmpLocate,
    'hydriver': hydriverLocate
};
export const locate = (option) => {
    const fn = xenvActionFactory('locate', xenvLocateConfig);
    try {
        window.PerfTrack.PrivateMethods.LocateStart();
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
    return fn(option)
        .then(res => {
        try {
            window.PerfTrack.PrivateMethods.LocateEnd();
            // eslint-disable-next-line no-empty
        }
        catch (_) { }
        return res;
    })
        .catch(error => {
        try {
            window.PerfTrack.PrivateMethods.LocateEnd();
            // eslint-disable-next-line no-empty
        }
        catch (_) { }
        return Promise.reject(error);
    });
};
